import {
    ACTIONS,
    PhlebognadminTypes,
} from "../interfaces/actionTypes/GenomicsCustomerExecutiveType";

type InitialState = {
    loading: boolean;
    userDetails: Array<any>;
    checkGeoFenceStatus: boolean;
    packageList: Array<any>;
    createBooking: Object;
    couponList: Array<any>;
    leads: Array<any>;
    lead_details: Object;
    leadById: Object;
    booking_slots: object;
    cities: Array<any>;
    imagingTimeSlots: Array<any>;
    redCoin: Array<any>;
    subCenter: Array<any>;
    pin_code: Array<any>;
    multiplePackage: Array<any>;
    displayCities: Array<any>;
    doctorInfo: Array<any>;
    areaList: Array<any>;
    agentsList: Array<any>;
    phleboList: Array<any>;
    partnerList: Array<any>;
    booking: Object;
    todays_positive_calls: Object;
    bookingList: Array<any>;
    notificationMessage: Array<any>;
    comment: any;
    data: any;
    users: any;
    bookingsComment: any;
    lead_id: number;
    read_call_details: object;
    all_recordings: object;
    whatsappComments: object;
    whatsappCommentsByLead: object;
    callStats: object;
    complaint: object;
    complaints: object;
    lead_source: any;
    search_results: object,
    call_status: object;
    all_lead: object;
    call_transfer: object;
    user_panel: object;
    agentBYUserGroup: object;
    sameNumberBooking: boolean;
    unmaskedNumber: Array<any>;
    additional_booking: object,
    createFamilyPackageBooking: Object;
    familyPackageBookingList: Array<any>;
    familyPackageList: Array<any>;
    reportDownload: Array<any>;
    reportStatus: Array<any>;
    partner_Id: object;
    createIMGBooking: object;
    mapmyindiaAccessToken: Array<any>;
    geoFencesMapMyIndia: Array<any>;
    bookingCall: Array<any>;
    addressType: Array<any>;
    paymentSendLink: Array<any>;
    paymentReSendLink: Array<any>;
    paymentCancelLink: Array<any>;
    smsReportSend: Array<any>;
    additionalBookingListWithTatTime: Array<any>;
    bookingListWithTatTime: Array<any>;
    qrcode: Array<any>;
    paymentModeList: Array<any>;
    stateList: Array<any>;
    salesManager: Array<any>;
    salesExecutive: Array<any>;
    identityProofData: Array<any>;
    rateListFilter: Array<any>;
    tagProccessingLab: Array<any>;
    doctorQual: Array<any>;
    doctorSpec: Array<any>;
    responseRefDoctor: Object;
    centreCode: Object;
    refDoctor: Array<any>;
    reportDownloadWithout: Object;
    bookingStatusCount: object;
    bookingStatus: Array<any>;
    bookingsByCentre: Array<any>;
    tubeByBooking: Array<any>;
    receivedPackages: Array<any>;
    updatebBookingData: Array<any>;

};

const initialState: InitialState = {
    loading: false,
    userDetails: [],
    tubeByBooking: [],
    checkGeoFenceStatus: false,
    packageList: [],
    bookingsByCentre: [],
    createBooking: {},
    couponList: [],
    leads: [],
    receivedPackages: [],
    bookingStatus: [],
    bookingStatusCount: {},
    doctorSpec: [],
    responseRefDoctor: {},
    lead_details: {},
    leadById: {},
    reportDownloadWithout: {},
    bookingCall: [],
    booking_slots: {},
    cities: [],
    imagingTimeSlots: [],
    redCoin: [],
    subCenter: [],
    bookingListWithTatTime: [],
    pin_code: [],
    multiplePackage: [],
    displayCities: [],
    doctorInfo: [],
    additional_booking: {},
    areaList: [],
    agentsList: [],
    phleboList: [],
    partnerList: [],
    booking: {},
    partner_Id: {},
    todays_positive_calls: {},
    bookingList: [],
    comment: {},
    data: {},
    users: {},
    read_call_details: {},
    all_recordings: {},
    whatsappComments: {},
    whatsappCommentsByLead: {},
    callStats: {},
    complaint: {},
    complaints: {},
    bookingsComment: {},
    lead_id: 0,
    lead_source: {},
    search_results: {},
    call_status: {},
    all_lead: {},
    call_transfer: {},
    agentBYUserGroup: {},
    notificationMessage: [],
    sameNumberBooking: false,
    user_panel: {},
    unmaskedNumber: [],
    familyPackageList: [],
    familyPackageBookingList: [],
    createFamilyPackageBooking: {},
    reportDownload: [],
    reportStatus: [],
    addressType: [],
    createIMGBooking: {},
    mapmyindiaAccessToken: [],
    geoFencesMapMyIndia: [],
    paymentSendLink: [],
    paymentReSendLink: [],
    paymentCancelLink: [],
    smsReportSend: [],
    additionalBookingListWithTatTime: [],
    qrcode: [],
    paymentModeList: [],
    stateList: [],
    salesManager: [],
    salesExecutive: [],
    identityProofData: [],
    rateListFilter: [],
    tagProccessingLab: [],
    centreCode: {},
    doctorQual: [],
    refDoctor: [],
    updatebBookingData: [],

};

const GenomicsCustomerExecutiveReducer = (
    state = initialState,
    action: PhlebognadminTypes
) => {
    switch (action.type) {

        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTIONS.GET_RECEIVED_PACKAGES:
            return {
                ...state,
                receivedPackages: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKINGS_BY_CENTRE:
            return {
                ...state,
                bookingsByCentre: action.payload,
                loading: false,
            };
        case ACTIONS.GET_TUBE_BY_BOOKING:
            return {
                ...state,
                tubeByBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_STATUS_COUNT:
            return {
                ...state,
                bookingStatusCount: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_STATUS:
            return {
                ...state,
                bookingStatus: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REPORT_DOWNLOAD_WITHOUT:
            return {
                ...state,
                reportDownloadWithout: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DOCTOR_SPEC:
            return {
                ...state,
                doctorSpec: action.payload,
                loading: false,
            };
        case ACTIONS.UPDATE_BOOKING:
            return {
                ...state,
                updatebBookingData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REPORT_DOWNLOAD_WITHOUT:
            return {
                ...state,
                reportDownloadWithout: action.payload,
                loading: false,
            };
        case ACTIONS.REF_DOCTOR_RESET:
            return {
                ...state,
                responseRefDoctor: {},
            };
        case ACTIONS.BOOKING_DATA_RESET:
            return {
                ...state,
                createIMGBooking: {},
                receivedPackages: {},
                tubeByBooking: {},
                updatebBookingData: {},


            };
        case ACTIONS.GET_REF_DOCTOR:
            return {
                ...state,
                refDoctor: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DOCTOR_QUAL:
            return {
                ...state,
                doctorQual: action.payload,
                loading: false,
            };
        case ACTIONS.POST_REF_DOCTOR:
            return {
                ...state,
                responseRefDoctor: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CENTER_INFORMATION:
            return {
                ...state,
                centerInfo: action.payload,
                loading: false,
            };
        case ACTIONS.GET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload,
                loading: false,
            };
        case ACTIONS.CHECK_GEOFENCE_AREA:
            return {
                ...state,
                checkGeoFenceStatus: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PACKAGES:
            return {
                ...state,
                packageList: action.payload,
                loading: false,
            };
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTIONS.CREATE_BOOKING:
            return {
                ...state,
                createBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_COUPONS:
            return {
                ...state,
                couponList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEADS:
            return {
                ...state,
                leads: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_DETAILS:
            return {
                ...state,
                lead_details: action.payload,
                loading: false,
            };
        case ACTIONS.LEAD_DETAILS_RESET:
            return {
                ...state,
                leadById: {},
                lead_details: {},
                leads: [],
                loading: false,
            };
        case ACTIONS.GET_AVAILABLE_SLOTS:
            return {
                ...state,
                booking_slots: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CITIES:
            return {
                ...state,
                cities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_IMAGING_TIMESLOTS:
            return {
                ...state,
                imagingTimeSlots: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_IMAGING_BOOKING:
            return {
                ...state,
                createIMGBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_RED_COIN:
            return {
                ...state,
                redCoin: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SUB_CENTER_INFORMATION:
            return {
                ...state,
                subCenter: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PIN_CODE:
            return {
                ...state,
                pin_code: action.payload,
                loading: false,
            };
        case ACTIONS.GET_MULTIPLE_PACKAGES:
            return {
                ...state,
                multiplePackage: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DISPLAY_CITIES:
            return {
                ...state,
                displayCities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DOCTOR_INFO_BY_ID:
            return {
                ...state,
                doctorInfo: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PIN_CODE:
            return {
                ...state,
                pin_code: action.payload,
                loading: false,
            };
        case ACTIONS.UPLOAD_FILE:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PHLEBOS:
            return {
                ...state,
                phleboList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_LIST_WITH_TAT_TIME:
            return {
                ...state,
                bookingListWithTatTime: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_CALLS:
            return {
                ...state,
                bookingCall: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CITIES:
            return {
                ...state,
                cities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_AREA:
            return {
                ...state,
                areaList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_POSTIVE_CALLS_COMMENTS:
            return {
                ...state,
                todays_positive_calls: action.payload,
                loading: false,
            };
        case ACTIONS.SET_COMMENTS:
            return {
                ...state,
                comment: action.payload,
                loading: false,
            };
        case ACTIONS.ADD_POSTIVE_CALLS_COMMENT:
            return {
                ...state,
                todays_positive_calls: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_DETAILS:
            return {
                ...state,
                lead_details: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEADS:
            return {
                ...state,
                leads: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_BY_ID:
            return {
                ...state,
                leadById: action.payload,
                loading: false,
            };
        case ACTIONS.LEAD_DETAILS_RESET:
            return {
                ...state,
                leadById: {},
                lead_details: {},
                loading: false,
            };
        case ACTIONS.GET_AGENTS:
            return {
                ...state,
                agentsList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_AGENTS_BY_USERGROUP:
            return {
                ...state,
                agentBYUserGroup: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PACKAGES:
            return {
                ...state,
                packageList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PARTNERS:
            return {
                ...state,
                partnerList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_COUPONS:
            return {
                ...state,
                couponList: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_BOOKING:
            return {
                ...state,
                createBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_LIST:
            return {
                ...state,
                bookingList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BOOKING_BY_ID:
            return {
                ...state,
                booking: action.payload,
                loading: false,
            };
        case ACTIONS.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ACTIONS.CREATE_CALL:
            return {
                ...state,
                loading: false,
                lead_id: action.payload,
            };
        case ACTIONS.GET_RECORDINGS:
            return {
                ...state,
                all_recordings: action.payload,
                loading: false,
            };
        case ACTIONS.GET_LEAD_SOURCE:
            return {
                ...state,
                lead_source: action.payload,
                loading: false,
            };
        case ACTIONS.SEARCH_CALL:
            return {
                ...state,
                search_results: action.payload,
                loading: false,
            };
        case ACTIONS.ADD_COMMENT:
            return {
                ...state,
                comments: action.payload,
                loading: false,
            };
        case ACTIONS.BOOKING_RESET:
            return {
                ...state,
                createBooking: {},
                bookingList: [],
                updatebBookingData: {},
                loading: false,
            };
        case ACTIONS.GET_BOOKINGS_COMMENTS:
            return {
                ...state,
                bookingsComment: action.payload,
                loading: false,
            };
        case ACTIONS.ADD_BOOKINGS_COMMENT:
            return {
                ...state,
                bookingsComment: action.payload,
                loading: false,
            };
        case ACTIONS.GET_WHATSAPP_COMMENTS:
            return {
                ...state,
                whatsappComments: action.payload,
                loading: false,
            };
        case ACTIONS.GET_WHATSAPP_COMMENTS_BY_LEAD:
            return {
                ...state,
                whatsappCommentsByLead: action.payload,
                loading: false,
            };
        case ACTIONS.SEND_WHATSAPP_COMMENTS:
            return {
                ...state,
                whatsappComments: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CALL_STATS:
            return {
                ...state,
                callStats: action.payload,
                loading: false,
            };
        case ACTIONS.RAISE_COMPLAINT:
            return {
                ...state,
                complaint: action.payload,
                loading: false,
            };
        case ACTIONS.GET_COMPLAINTS:
            return {
                ...state,
                complaints: action.payload,
                loading: false,
            };
        case ACTIONS.ASSIGN_DOCTOR:
            return {
                ...state,
                success: true,
                loading: false,
            };
        case ACTIONS.SEND_FEEDBACK:
            return {
                ...state,
                success: true,
                loading: false,
            };
        case ACTIONS.GET_AVAILABLE_SLOTS:
            return {
                ...state,
                booking_slots: action.payload,
                loading: false,
            };
        case ACTIONS.GET_ALL_LEADS:
            return {
                ...state,
                all_lead: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PANEL_USERS:
            return {
                ...state,
                user_panel: action.payload,
                loading: false,
            };
        case ACTIONS.LEAD_TRANSFER_BY_COMMA:
            return {
                ...state,
                all_lead: action.payload,
                loading: false,
            };
        case ACTIONS.SAME_NUMBER_BOOKING:
            return {
                ...state,
                sameNumberBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_NOTIFICATION_MESSAGE:
            return {
                ...state,
                notificationMessage: action.payload,
                loading: false,
            };
        case ACTIONS.GET_UNMASKED_NUMBER:
            return {
                ...state,
                unmaskedNumber: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_ADDITIONAL_BOOKING:
            return {
                ...state,
                additional_booking: action.payload,
                loading: false,
            };
        case ACTIONS.CHECK_GEOFENCE_AREA:
            return {
                ...state,
                checkGeoFenceStatus: action.payload,
                loading: false,
            };
        case ACTIONS.GET_FAMILY_PACKAGES:
            return {
                ...state,
                familyPackageList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_FAMILY_PACKAGES_BOOKING:
            return {
                ...state,
                familyPackageBookingList: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_FAMILY_PACKAGES_BOOKING:
            return {
                ...state,
                createFamilyPackageBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REPORT_DOWNLOAD:
            return {
                ...state,
                reportDownload: action.payload,
                loading: false,
            };
        case ACTIONS.GET_REPORT_STATUS:
            return {
                ...state,
                reportStatus: action.payload,
                loading: false,
            };
        case ACTIONS.GET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PARTNERS_ID:
            return {
                ...state,
                partner_Id: action.payload,
                loading: false,
            };
        case ACTIONS.GET_RED_COIN:
            return {
                ...state,
                redCoin: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SUB_CENTER_INFORMATION:
            return {
                ...state,
                subCenter: action.payload,
                loading: false,
            };
        case ACTIONS.GET_IMAGING_TIMESLOTS:
            return {
                ...state,
                imagingTimeSlots: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_IMAGING_BOOKING:
            return {
                ...state,
                createIMGBooking: action.payload,
                loading: false,
            };
        case ACTIONS.GET_MULTIPLE_PACKAGES:
            return {
                ...state,
                multiplePackage: action.payload,
                loading: false,
            };
        case ACTIONS.GET_DISPLAY_CITIES:
            return {
                ...state,
                displayCities: action.payload,
                loading: false,
            };
        case ACTIONS.GET_MAMPMYINDIA_ACCESS_TOKEN:
            return {
                ...state,
                mapmyindiaAccessToken: action.payload,
                loading: false,
            };
        case ACTIONS.GET_ADDRESS_TYPE_SEATING:
            return {
                ...state,
                addressType: action.payload,
                loading: false,
            };
        case ACTIONS.CHECK_GEOFENCE_AREA_MAMPMYINDIA:
            return {
                ...state,
                geoFencesMapMyIndia: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CENTER_INFORMATION:
            return {
                ...state,
                centerInfo: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PAYMENT_SEND_LINK:
            return {
                ...state,
                paymentSendLink: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PAYMENT_RESEND_LINK:
            return {
                ...state,
                paymentReSendLink: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PAYMENT_CANCEL_LINK:
            return {
                ...state,
                paymentCancelLink: action.payload,
                loading: false,
            };
        case ACTIONS.GET_PAYMENT_MODE_LIST:
            return {
                ...state,
                paymentModeList: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SMS_REPORT_SEND:
            return {
                ...state,
                smsReportSend: action.payload,
                loading: false,
            };
        case ACTIONS.GET_STATE_LIST:
            return {
                ...state,
                stateList: action.payload,
                loading: false,
            };
        case ACTIONS.CREATE_NEW_CENTER:
            return {
                ...state,
                createCenter: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SALES_MANAGER:
            return {
                ...state,
                salesManager: action.payload,
                loading: false,
            };
        case ACTIONS.GET_SALES_EXECUTIVE:
            return {
                ...state,
                salesExecutive: action.payload,
                loading: false,
            };
        case ACTIONS.GET_IENTITY_PROOF_DATA:
            return {
                ...state,
                identityProofData: action.payload,
                loading: false,
            };
        case ACTIONS.GET_RATELIST_FILTER:
            return {
                ...state,
                rateListFilter: action.payload,
                loading: false,
            };
        case ACTIONS.GET_TAG_PROCCESSING_LAB:
            return {
                ...state,
                tagProccessingLab: action.payload,
                loading: false,
            };
        case ACTIONS.GET_CENTRE_CODE:
            return {
                ...state,
                centreCode: action.payload,
                loading: false,
            };
        case ACTIONS.GET_BANK_NAME:
            return {
                ...state,
                bankName: action.payload,
                loading: false,
            };
        case ACTIONS.GET_ADDITIONAL_BOOKING_LIST_WITH_TAT_TIME:
            return {
                ...state,
                additionalBookingListWithTatTime: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};

export default GenomicsCustomerExecutiveReducer;
